module.exports = __webpack_public_path__ + "bc5668d0975198df601af47ff90e6b05.svg";